export interface InfoTooltipListenerParams {
    onPointerOver: (event: PointerEvent) => void;
    onPointerOut: (event: PointerEvent) => void;
    onScroll: () => void;
    onResize: () => void;
    onKeydown: (event: KeyboardEvent) => void;
    onClick: (event: MouseEvent) => void;
}

export class InfoTooltipListener {
    public static register(params: InfoTooltipListenerParams): void {
        document.addEventListener("pointerover", params.onPointerOver as EventListener, true);
        document.addEventListener("pointerout", params.onPointerOut as EventListener, true);
        document.addEventListener("scroll", params.onScroll as EventListener, true);
        document.defaultView?.addEventListener("resize", params.onResize);
        document.addEventListener("keydown", params.onKeydown as EventListener);
        document.addEventListener("click", params.onClick as EventListener);
    }
}
